import React from 'react';
import {CircularProgress, LinearProgress, Stack} from "@mui/material";

const LoadingProgress = () => {
    return (
        <Stack
          id={"linear-progress"}
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
                position: "fixed",
                height: "4px",
                top: -1,
                left: 0,
                right: 0,
                bgcolor: "#FFF",
                zIndex: 100000
            }}
        >
          <LinearProgress variant={"indeterminate"} sx={{height: "4px", width: "100%"}} />
        </Stack>
    );
};

export default LoadingProgress;
